(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloFunzioneDeleteController',RuoloFunzioneDeleteController);

    RuoloFunzioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'RuoloFunzione'];

    function RuoloFunzioneDeleteController($uibModalInstance, entity, RuoloFunzione) {
        var vm = this;

        vm.ruoloFunzione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RuoloFunzione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
